<template>
    <div>
        <div class="my-editInfo" v-if="!isWeixin">
            <div class="bd">
                <div class="sq-notice">
                    <div class="weui-msg">
                        <div class="weui-msg__icon-area">
                            <i class="el-icon-warning" style="color: #2b94ff;font-size:100px">
                            </i>
                        </div>
                        <div class="weui-msg__text-area">
                            <h2 class="weui-msg__title">温馨提示</h2>
                            <p class="weui_msg__desc">{{notice}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-editInfo" v-if="isWeixin&&status=='LB'">
            <div class="bd">
                <div class="md-items">
                    <span class="mdbt">选择门店</span>
                    <div class="md-item" v-for="mb in mbs">
                        <div class="fw-mduser">
                            <div style="display: flex;flex-direction: row;align-items: center">
                                <i class="el-icon-s-shop" style="font-size: 20px;color:#777777;margin-right: 5px"/>
                                <span>{{mb.deptName}}</span>
                            </div>
                            <span class="jinruEmp" @click="jinruUser(mb)">进入</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="my-editInfo" v-if="isWeixin&&status=='BD'">
            <span class="miaoshu">请确认您的手机号码在扫码门店注册成功，否则无法绑定!</span>
            <div class="bd-content" style="margin-top: 28px">
                <div class="bd-content-wai">
                    <van-cell-group :border="false">
                        <van-field
                                label-width="50px"
                                v-model="phone"
                                label="手机号"
                                placeholder="请输入您的手机号码"
                                type="tel"
                        />
                    </van-cell-group>
                    <div style="text-align: center;margin-top: 30%;">
                        <van-button type="primary" style="width: 88%;" @click="saveMember">立即绑定</van-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getCookie, setCookie,delCookie} from "../../utils/auth";

    export default {
        data() {
            return {
                memberName: '',
                sex: '1',
                phone: '',
                headPortrait: '',
                openId: '',
                deptName: '',
                code: '',
                user: {},

                appId: '',
                deptId: '',
                source: '',
                mdId: '',
                notice: '请在微信客户端打开链接!',
                isWeixin: false,
                status: '',
                mbs: [],
                url:'https://vipyd.fanboshi.net/#/mys'
            };
        },
        created: async function () {
            document.title = "用户授权"
            this.deptId = this.$route.query.deptId
            this.source = this.$route.query.source
            await this.panduan()
            if (this.isWeixin) {
                if (getCookie("fwUser")) {
                    this.fwUser = JSON.parse(getCookie("fwUser"))
                    if (this.fwUser.userType == 5) {
                        window.location.href = this.url
                        return;
                    } else {
                        delCookie("fwUser")
                    }
                }
                await this.getFwGzh()
                if (this.appId) {
                    this.code = ''
                    await this.getCode()
                }
            }
        },

        methods: {
            panduan() {
                let that = this;
                var ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器
                var isWeixin = ua.indexOf("micromessenger") != -1; //判断是否
                this.isWeixin = isWeixin
                if (!isWeixin) {
                    return false;
                }
            },
            async getFwGzh() {
                let res = await this.$get("/fw/getFwGzh", {deptId: this.deptId})
                if (res.code == 200) {
                    this.appId = res.gzhInfo.gzhAppid
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },
            async fwLogin(code) {
                let data = {
                    code: code,
                    deptId: this.deptId,
                    source: this.source,
                }
                let res = await this.$post("/fw/fwsqLogin", data)
                if (res.code == 200) {
                    if (res.status == 'DL') {
                        setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                        window.location.href =this.url
                    }
                    if (res.status == 'LB') {
                        this.status = res.status
                        this.mbs = res.mbs
                    }
                    if (res.status == 'BD') {
                        this.status = res.status
                        let info = res.userMap
                        this.deptName = info.deptName
                        this.memberName = info.nickname
                        if (info.sex == '1' || info.sex == '2') {
                            this.sex = info.sex
                        } else {
                            this.sex = '1'
                        }
                        this.headPortrait = info.headimgurl
                        this.openId = info.openId
                    }
                } else {
                    this.$notify({type: 'danger', message: res.message});
                    // window.location.href = `https://fw.fanboshi.net/#/members`
                }
            },

            async saveMember() {
                if (!this.phone) {
                    this.$notify({type: 'danger', message: "手机号不能为空"});
                    return;
                }
                if (!this.openId) {
                    this.$notify({type: 'danger', message: "获取的微信用户信息不完整,不能绑定"});
                    return;
                }
                let data = {
                    phone: this.phone,
                    openId: this.openId,
                    deptId: this.deptId,
                }
                let res = await this.$post("/fw/bdFwMember", data)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                    window.location.href = this.url
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async jinruUser(item) {
                let data = {
                    id: item.id,
                    registerId: item.registerId,
                    deptName: item.deptName,
                    memberName: item.memberName,
                    phone: item.phone,
                }
                let res = await this.$post("/fw/fwSetMember", data)
                if (res.code == 200) {
                    setCookie('fwUser', JSON.stringify(res.fwUser), 30)
                    window.location.href = this.url
                }
            },
            getCode() { // 非静默授权，第一次有弹框
                const code = this.getUrlParam("code"); // 截取路径中的code
                this.code = code
                if (this.code == null || this.code === '') { // 如果没有code，则去请求
                    var local = window.location.href // 获取页面url
                    var appid = this.appId
                    window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123&connect_redirect=1#wechat_redirect`
                } else {
                    this.fwLogin(this.code)
                }
            },

            // 编码函数
            getUrlParam(name) {
                var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
                var r = window.location.search.substr(1).match(reg); //匹配目标参数
                if (r != null) return unescape(r[2]);
                return null; //返回参数值
            },
        },
    };

</script>

<style lang="scss" scoped>
    .my-editInfo {
        margin: 0 auto;
        height: 100%;
        /*background-color: #EDEDED;*/
        background-size: 100% 100%;
    }

    .miaoshu {
        display: block;
        font-size: 13px;
        text-align: center;
        height: 68px;
        line-height: 68px;
    }

    .van-cell {
        position: relative;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        box-sizing: border-box;
        width: 100%;
        padding: 0.26667rem 0.42667rem;
        overflow: hidden;
        color: #323233;
        font-size: 0.37333rem;
        line-height: 0.64rem;
        background-color: #fff;
        border-bottom: #dddddd solid 1px;
    }

    .bd {
        width: 65%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .bd-content {
        width: 100%;
        padding-top: 25px;
        padding-bottom: 25px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        background-color: #fff;
    }

    .bd-content-wai {
        width: 88%;
    }

    .imgs {
        width: 70px;
        height: 70px;
        position: absolute;
        top: -35px;
        left: 38%;
    }

    .res {
        color: rgb(153, 153, 153);
        font-weight: bold;
        font-size: 13px;
        background-color: rgb(255, 255, 255);
        margin: 0 auto;
        line-height: 46px;
        text-align: center;
        box-shadow: 0 3px 3px rgba(21, 62, 78, 0.8);
        margin-top: 20px;
    }

    .regis {
        color: rgb(52, 119, 182);
        cursor: pointer;
    }

    .van-button {
        height: 32px;
    }

    .van-button--primary {
        color: #fff;
        background-color: #8359F9;
        border: 1px solid darkgray;
    }

    ::v-deep .van-radio__icon {
        display: inline-block;
        vertical-align: middle;
        line-height: 20px;
        font-size: 15px;
    }

    .sq-index {
        overflow: hidden;
    }

    .sq-notice {
        margin: auto;
        font-size: 18px;
        text-align: center;
        margin-top: 23%;
    }

    .weui-msg {
        padding-top: 36px;
        text-align: center;
    }

    .weui-msg__icon-area {
        margin-bottom: 30px;
    }

    .weui-icon_msg {
        font-size: 93px;
    }

    .weui-icon-info {
        font-size: 23px;
        color: #10aeff;
    }

    .weui-msg__text-area {
        margin-bottom: 25px;
        padding: 0 20px;
    }

    .weui-msg__title {
        margin-bottom: 5px;
        font-weight: 400;
        font-size: 20px;
    }

    .weui_msg__desc {
        margin-top: 16px;
    }

    .md-items {
        display: flex;
        flex-direction: column;
        overflow: auto;
        height: 100%;
        background-color: #FFFFFF;
        padding-top: 12px;
        padding-bottom: 3px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
    }

    .md-item {
        width: 90%;
        margin: auto;
        padding: 8px 20px;
        font-size: 13px;
        display: flex;
        flex-direction: column;
        background-color: #eeeeee;
        border-radius: 3px;
        margin-bottom: 10px;
    }

    .fw-mduser {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .jinruEmp {
        padding: 3px 8px;
        background-color: #2b94ff;
        border-radius: 3px;
        color: #ffffff;
    }

    .mdbt {
        font-size: 13px;
        display: block;
        text-align: center;
        margin-bottom: 20px;
    }


</style>
